<template>
  <ExamStart :path="'/entrain'" style="margin-top: 121px;"></ExamStart>
</template>

<script>
  import ExamStart from '@/page/modules/exam/start'
  export default {
    components: { ExamStart },
    mounted () {
    },
    data () {
      return {
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/page/entrain/exam/start.vue